module.exports = __webpack_public_path__ + "img/1.b8cc801c.png";